var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "level" },
          [
            _c(
              "Header",
              _vm._b(
                { staticClass: "level-left" },
                "Header",
                _vm.$route.meta,
                false
              )
            ),
            _c(
              "b-button",
              {
                staticClass: "left-right",
                attrs: {
                  type: "is-success",
                  "icon-left": "plus",
                  disabled: _vm.selectedPlant === null,
                },
                on: {
                  click: function ($event) {
                    return _vm.showCreateForm()
                  },
                },
              },
              [_vm._v(" New NCR ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Start Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "startdate",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "Start date",
                        },
                        model: {
                          value: _vm.start,
                          callback: function ($$v) {
                            _vm.start = $$v
                          },
                          expression: "start",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "End Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "enddate",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "End date",
                        },
                        model: {
                          value: _vm.end,
                          callback: function ($$v) {
                            _vm.end = $$v
                          },
                          expression: "end",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.user.group.plants && _vm.user.group.plants.length != 0
                    ? _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: { icon: "industry", expanded: "" },
                              model: {
                                value: _vm.selectedPlant,
                                callback: function ($$v) {
                                  _vm.selectedPlant = $$v
                                },
                                expression: "selectedPlant",
                              },
                            },
                            _vm._l(_vm.user.group.plants, function (plant) {
                              return _c(
                                "option",
                                { key: plant.id, domProps: { value: plant } },
                                [_vm._v(" " + _vm._s(plant.name) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c("multiselect", {
                            staticStyle: { "min-width": "400px" },
                            attrs: {
                              options: _vm.plants,
                              multiple: false,
                              "close-on-select": true,
                              placeholder: "Pick plant",
                              "custom-label": (obj) =>
                                obj.id + " - " + obj.name,
                              "track-by": "name",
                            },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "left-right",
                      attrs: {
                        type: "is-warning",
                        "icon-left": "arrows-rotate",
                        disabled: _vm.isLoading || _vm.selectedPlant === null,
                      },
                      on: {
                        click: () => {
                          _vm.resetData()
                          _vm.getData()
                        },
                      },
                    },
                    [_vm._v(" Load ")]
                  ),
                ],
                1
              ),
              _vm.ncr.length != 0
                ? _c("ag-grid-vue", {
                    staticClass: "ag-theme-balham",
                    staticStyle: { width: "100%", height: "700px" },
                    attrs: {
                      "row-data": _vm.ncr,
                      "grid-options": _vm.gridOptions,
                      pagination: true,
                      "pagination-auto-page-size": true,
                      "cache-overflow-size": 0,
                      "multi-sort-key": "ctrl",
                      modules: _vm.modules,
                      "get-context-menu-items": _vm.getContextMenuItems,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCreatingNCR,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreatingNCR = $event
            },
          },
        },
        [
          _vm.isCreatingNCR
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitNCR.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Create NCR "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Date" } },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "newdate",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                    },
                                    model: {
                                      value: _vm.newNCR.date,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.newNCR, "date", $$v)
                                      },
                                      expression: "newNCR.date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "OB" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.newNCR.ob,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newNCR, "ob", $$v)
                                  },
                                  expression: "newNCR.ob",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Client" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.customers,
                                  multiple: false,
                                  "close-on-select": true,
                                  placeholder: "Select Customer",
                                  "custom-label": (obj) =>
                                    obj.id + " - " + obj.name,
                                  "track-by": "name",
                                },
                                model: {
                                  value: _vm.newNCR.client,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newNCR, "client", $$v)
                                  },
                                  expression: "newNCR.client",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Site de destination" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.plants,
                                  multiple: false,
                                  "close-on-select": true,
                                  placeholder: "Pick plant",
                                  "custom-label": (obj) =>
                                    obj.id + " - " + obj.name,
                                  "track-by": "name",
                                },
                                model: {
                                  value: _vm.newNCR.dest_site,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newNCR, "dest_site", $$v)
                                  },
                                  expression: "newNCR.dest_site",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Site de provenance" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.plants,
                                  multiple: false,
                                  "close-on-select": true,
                                  placeholder: "Pick plant",
                                  "custom-label": (obj) =>
                                    obj.id + " - " + obj.name,
                                  "track-by": "name",
                                },
                                model: {
                                  value: _vm.newNCR.prov_site,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newNCR, "prov_site", $$v)
                                  },
                                  expression: "newNCR.prov_site",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Caisses Résponsabilité GPS" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.newNCR.resp_gps,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newNCR, "resp_gps", $$v)
                                  },
                                  expression: "newNCR.resp_gps",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            {
                              attrs: { label: "Caisses Résponsabilité Client" },
                            },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.newNCR.resp_client,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newNCR, "resp_client", $$v)
                                  },
                                  expression: "newNCR.resp_client",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantité totale" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.newNCR.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newNCR, "quantity", $$v)
                                  },
                                  expression: "newNCR.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingNCR,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingNCR = $event
            },
          },
        },
        [
          _vm.isEditingNCR
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitEdit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Edit NCR "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Date" } },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "newdate",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                    },
                                    model: {
                                      value: _vm.editableNCR.date,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.editableNCR, "date", $$v)
                                      },
                                      expression: "editableNCR.date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "OB" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.editableNCR.ob,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableNCR, "ob", $$v)
                                  },
                                  expression: "editableNCR.ob",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Client" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.customers,
                                  multiple: false,
                                  "close-on-select": true,
                                  placeholder: "Select Customer",
                                  "custom-label": (obj) =>
                                    obj.id + " - " + obj.name,
                                  "track-by": "name",
                                },
                                model: {
                                  value: _vm.editableNCR.client,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableNCR, "client", $$v)
                                  },
                                  expression: "editableNCR.client",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Site de destination" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.plants,
                                  multiple: false,
                                  "close-on-select": true,
                                  placeholder: "Pick plant",
                                  "custom-label": (obj) =>
                                    obj.id + " - " + obj.name,
                                  "track-by": "name",
                                },
                                model: {
                                  value: _vm.editableNCR.dest_site,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableNCR, "dest_site", $$v)
                                  },
                                  expression: "editableNCR.dest_site",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Site de provenance" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.plants,
                                  multiple: false,
                                  "close-on-select": true,
                                  placeholder: "Pick plant",
                                  "custom-label": (obj) =>
                                    obj.id + " - " + obj.name,
                                  "track-by": "name",
                                },
                                model: {
                                  value: _vm.editableNCR.prov_site,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableNCR, "prov_site", $$v)
                                  },
                                  expression: "editableNCR.prov_site",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Caisses Résponsabilité GPS" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.editableNCR.resp_gps,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableNCR, "resp_gps", $$v)
                                  },
                                  expression: "editableNCR.resp_gps",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            {
                              attrs: { label: "Caisses Résponsabilité Client" },
                            },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.editableNCR.resp_client,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableNCR,
                                      "resp_client",
                                      $$v
                                    )
                                  },
                                  expression: "editableNCR.resp_client",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Quantité totale" } },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.editableNCR.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableNCR, "quantity", $$v)
                                  },
                                  expression: "editableNCR.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }